import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const events = new Set(["project_view", "signup_click", "signup_started", "signup_completed", "pilot_started", "pilot_submitted", "checkout_started", "mcp_connected", "deployment_healthy"]);
const sources = new Set(["landing", "library", "pilot", "login", "dashboard", "marketplace"]);
const projects = new Set(["ecommerce", "own_repo"]);

// Only bounded categories leave the page. Never send form values, URLs or MCP keys.
export function trackLimeliteEvent(event, details = {}, consent = false) {
  if (consent !== true || !events.has(event) || !sources.has(details.source)) return;
  return axios.post("/api/analytics/funnel", {
    event,
    source: details.source,
    projectType: projects.has(details.projectType) ? details.projectType : "unspecified",
  }).catch(() => {});
}

export function useLimeliteFunnel() {
  const auth = useAuth();
  return useCallback((event, details) => {
    if (auth?.user) return; // Main-site authenticated users are staff.
    return trackLimeliteEvent(event, details, auth?.consentGiven === true);
  }, [auth?.consentGiven, auth?.user]);
}

export function selectedProject(value) {
  return projects.has(value) ? value : null;
}
